namespace SPA {

	export namespace types {

		export namespace Address {

			export enum State {
				BW = 'Baden-Württemberg',
				BY = 'Bayern',
				BE = 'Berlin',
				BB = 'Brandenburg',
				HB = 'Bremen',
				HH = 'Hamburg',
				HE = 'Hessen',
				MV = 'Mecklenburg-Vorpommern',
				NI = 'Niedersachsen',
				NW = 'Nordrhein-Westfalen',
				RP = 'Rheinland-Pfalz',
				SL = 'Saarland',
				SN = 'Sachsen',
				ST = 'Sachsen-Anhalt',
				SH = 'Schleswig-Holstein',
				TH = 'Thüringen'
			}

			export enum Country {
				DE = 'Deutschland',
				AT = 'Österreich',
				NL = 'Niederlande',
				CH = 'Schweiz'
			}

			export enum Type {
				seller = 'Verkäufer',
				contact = 'Kontakt',
				owner = 'Eigentümer',
				// owner = 'Objekt-EiVerkäufer',
				// contact = 'Objekt-Kontakt',
				// owner = 'Objekt-Eigentümer',
				bidder = 'Kaufinteressent',
				adviser = 'Berater',
				partner = 'Partner',
				customer = 'Kunde'
			}
		}
		export namespace Contact {

			export enum CivilStatus {
				LD = 'ledig',
				VH = 'verheiratet',
				VW = 'verwitwet',
				GS = 'geschieden',
				EA = 'Ehe aufgehoben',
				LP = 'in eigentragener Lebenspartnerschaft',
				LV = 'durch Tod aufgelöste Lebenspartnerschaft',
				LA = 'aufgehobene Lebenspartnerschaft',
				LE = 'durch Todeserklärung aufgelöste Lebenspartnerschaft',
				NB = 'nicht bekannt'
			}

			export enum Employment {
				ANG = 'Angestellter',
				SBST = 'Selbständiger',
				RENT = 'Rentner',
				OFFICER = 'Beamter',
				CIVIL = 'öffentlicher Dienst',
				FREELANCE = 'Freiberufler',
			}
		}

		export namespace Object {

			export enum Type {
				DHH = 'Doppelhaushälfte',
				EFH = 'Einfamilienhaus',
				ETW = 'Eigentumswohnung',
				MFH = 'Mehrfamilienhaus',
				REH = 'Reihenendhaus',
				RMH = 'Reihenmittelhaus',
				ZFH = 'Zweifamilienhaus',
				GST = 'Grundstück',
			}

			export enum BuildingPhase {
				PLANING = 'in Planung',
				CONSTRUCTION = 'in Bau',
				BUILT = 'fertiggestellt',
			}

			export enum Condition {
				VERY_GOOD = 'Sehr gut',
				GOOD = 'Gut',
				SATISFYING = 'Befriedigend',
				SUFFICIENT = 'Ausreichend',
				INADEQUAT = 'Mangelhaft'
			}

			export enum Interior {
				1 = 'einfach',
				2 = 'mittel',
				3 = 'gehoben',
				4 = 'stark gehoben',
				5 = 'luxuriös'
			}

			export enum Marketing {
				DisposalRealtorObject = 'Verkauf',
				LetRealtorObject = 'Vermietung',
			}

			export enum EnergieCertificate {
				none = "Nicht ausgestellt",
				needs = "Bedarfsausweis",
				consumption = "Verbrauchsausweis",
			}

			export enum HeatingType {
				central = 'Zentralheizung',
				per_floor = 'Dezentral je Etage',
				per_unit = 'Dezentral je Wohneinheit',
			}

			export enum HeatingFeature {
				biomass = 'Biomasse',
				geothermal_pump = 'Erdwärmepumpe',
				district = 'Fernwärme',
				gas = 'Gas',
				log_man = 'Holzscheit (manuell)',
				log_auto = 'Holzscheit (automatisch)',
				coal = 'Kohle',
				air_heat_exchanger = 'Luftwärmetauscher',
				oil = 'Öl',
				pellet = 'Pellet',
				plant_oil = 'Pflanzenöl',
				solar = 'Solarunterstützt',
				radiation = 'Strahlungsheizung',
				electricity = 'Strom',
			}

			export enum ParkingSegment {
				GARAGE = 'Garage',
				PARKING = 'Stellplatz',
				CARPORT = 'Carport',
				UNDERGROUND = 'Tiefgarage'
			}
		}

		export enum Salutation {
			MR = 'Herr',
			MRS = 'Frau',
			Herr = 'Herr',
			Frau = 'Frau'
		}

		export enum Gender {
			m = 'Herr',
			w = 'Frau'
		}

		export enum HouseState {

		}

		export enum YesNo {
			NO = 'Nein',
			YES = 'Ja'
		}

		export enum InActive {
			INACTIVE = 'Inaktiv',
			ACTIVE = 'Aktiv',
			SELLED = 'Verkauft'
		}

		export namespace Convert
		{

			export function ToObjectList(type: any): { [key: string]: string } {
				const data: { [key: string]: string } = {};
				for (const key in type) {
					data[key] = type[key];
				}

				return data;
			}

			export function ToArray(type: any): Array<{key: string, value: any}>
			{
				const data: Array<{key: string, value: any}> = [];
				for (const key in type) {
					data.push({
						key,
						value: type[key]
					});
				}

				return data;
			}
		}

	}
}
